import { compareTime } from "./time";

export interface Versioned {
  id: string;
  updatedAt: string;
}

export function mergeById<T extends Versioned>(current: T[], incoming: T[]): T[] {
  const map = new Map<string, T>();
  for (const item of current) map.set(item.id, item);
  for (const item of incoming) {
    const previous = map.get(item.id);
    if (!previous || compareTime(item.updatedAt, previous.updatedAt) >= 0) {
      map.set(item.id, item);
    }
  }
  return [...map.values()];
}

export function visibleRows<T extends { deletedAt: string | null }>(rows: T[]): T[] {
  return rows.filter((row) => row.deletedAt == null);
}
